import React, { useEffect, useState } from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  TextField, Paper, TableContainer, Box,
  Typography, useTheme, styled,
  Grid2,
  Stack
} from '@mui/material';
import { useGetPendingDprPMQuery } from 'store/slices/apis/keyDPRPMSlice';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import PaginationComponent from 'components/ui-components/PaginationComponent';

const StyledTableCell = styled(TableCell)({
  whiteSpace: "nowrap",
  border: '1px solid #ccc',
  textAlign: "center",
});

const StyledTableBody = styled(TableCell)({
  fontWeight: 400,
  fontSize: "14px",
  color: "#5052588A",
  padding: "10px 14px",
  backgroundColor: "#fff",
  textAlign: "center",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  letterSpacing: "0.2px",
});

const DprPmSubmittedBy = () => {
  const theme = useTheme();
  const [search, setSearch] = useState('');
  const { projectId } = useParams();
  const [tableData, setTableData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1)
  const rowsPerPage = 10

  const { data } = useGetPendingDprPMQuery({ projectId });
  const allPm = data?.data || [];

  const startIndex = (pageNumber - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  useEffect(() => {
    if (allPm.length > 0) {
      const parsedData = allPm.map(item => {
        try {
          const parsed = JSON.parse(item.data);
          return {
            ...parsed,
            id: item.id,
            status: item.status,
            actionDate: item.actionDate
          };
        } catch (error) {
          console.error("Error parsing item.data:", item.data, error);
          return null;
        }
      }).filter(Boolean);
      setTableData(parsedData);
    }
  }, [data]);

  const handleSearchChange = (e) => setSearch(e.target.value);

  const filteredData = tableData.filter(row =>
    (row.PM || "").toLowerCase().includes(search.toLowerCase())
  );

  const paginatedData = filteredData.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  return (
    <Grid2 container spacing={2} sx={{ mt: "20px" }}>
      <Grid2 size={12}>
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: 'start', sm: 'center' },
            justifyContent: "space-between",
            flexDirection: { xs: 'column', sm: 'row' }
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            sx={{
              // flexGrow: 2,
              alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
              width: { xs: '100%', sm: 'auto' }, // Stack takes full width
              "& .MuiStack-root": {
                paddingTop: "15px",
              },
            }}
          >
            <TextField
              size='small'
              value={search}
              placeholder='Enter Equipment Name To Search'
              onChange={handleSearchChange}
              sx={{ width: { xs: '100%', sm: "400px" } }}
            />
          </Stack>
        </Box>
      </Grid2>

      <Grid2 size={12} sx={{ mt: 2 }}>
        <Paper elevation={2} >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Equipment Name</StyledTableCell>
                  <StyledTableCell>Equipment Category</StyledTableCell>
                  <StyledTableCell>Reporting Date</StyledTableCell>
                  <StyledTableCell>Tag</StyledTableCell>
                  <StyledTableCell>Available Hours</StyledTableCell>
                  <StyledTableCell>Operating Hours</StyledTableCell>
                  <StyledTableCell sx={{ whiteSpace: "normal", width: "150px" }}>
                    No. of Breakdowns
                  </StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedData.length === 0 ? (
                  <TableRow>
                    <StyledTableBody colSpan={7}>No data available</StyledTableBody>
                  </TableRow>
                ) : (
                  paginatedData.map((row, index) => (
                    <TableRow key={index}>
                      <StyledTableBody>{row.PM || "-"}</StyledTableBody>
                      <StyledTableBody>{row.Category || "-"}</StyledTableBody>
                      <StyledTableBody>
                        {row?.ReportingDate
                          ? dayjs(row.ReportingDate).format("DD-MM-YYYY")
                          : "-"}
                      </StyledTableBody>
                      <StyledTableBody>{row.Tag || "-"}</StyledTableBody>
                      <StyledTableBody>{row.AvailableHours ?? "-"}</StyledTableBody>
                      <StyledTableBody>{row.OperatingHours ?? "-"}</StyledTableBody>
                      <StyledTableBody>{row.BreakdownHours ?? "-"}</StyledTableBody>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1, pr: 2 }}>
          <PaginationComponent
            pageNumber={pageNumber}
            totalPages={totalPages || 1}
            onPageChange={setPageNumber}
          />
        </Box>
      </Grid2>

    </Grid2>
  );
};

export default DprPmSubmittedBy;
